import React from "react";
import './index.css'; // changed filename for clarity

const WelcomeBanner = ({user}) => {
  if (!user) return null; // or return a loading spinner or placeholder

const { fullName } = user;
  return (
    <div className="sweet-welcome-banner">
      <h3 className="sweet-welcome-title">Hello, {fullName}! 🍭 Ready to unwrap more sweetness?</h3>
      <p className="sweet-welcome-text">Manage your profile, track orders, and check your sweet rewards!</p>
    </div>
  );
};

export default WelcomeBanner;
